module.exports = __webpack_public_path__ + "static/img/stg.52cc45ad.png";